import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PaginationBlock3 from "../../../components/common/PaginationBlock3";
import {
  faEdit,
  faEye,
  faTrash,
  faRotate,
  faRightToBracket,
  faCheck,
  faCheckCircle,
  faQuestion,
  faCircleXmark,
  faMailForward,
} from "@fortawesome/free-solid-svg-icons";
import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
} from "reactstrap";
import PaginationBlock from "../../../components/common/PaginationBlock";
import StatusDropdown from "../StatusDropdown";
import { capitalizeFirstLetter } from "../../../utils/common";
import ReactTooltip from "react-tooltip";
import { useSelector } from "react-redux";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { resendEmail } from "../../../context/actions/operator";

import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { roleItems } from "../../../utils/constants";

const Listing = ({
  _update,
  users,
  sortKey,
  page,
  _setPage,
  _sort,
  _order,
  limit,
  _handleLimit,
  _handlePageChange,
  _handleUserStatusChange,
  _nameSort,
}) => {
  const dispatch = useDispatch();
  const MySwal = withReactContent(Swal);
  console.log(page, limit, users);
  const history = useHistory();
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const userId = useSelector((state) => state?.user?.user?._id);

  const _resendEmail = (data) => {
    if (data?.deleted) {
      toast.error("Please Activate the User to send the Email")
    } else {
      MySwal.fire({
        title: "Are you sure?",
        text: `Do you want to send Email to ${data?.fname + " " +data?.lname}`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.isConfirmed) {
          dispatch(
            resendEmail(data?._id, (res) => {
              if (res) {
                MySwal.fire({
                  title: "Email Sent",
                  text: `Email Sent to ${data?.fname}`,
                  icon: "success",
                  confirmButtonColor: "#3085d6",
                  confirmButtonText: "Okay",
                });
              }
            })
          );
        }
      });
    }
  };
  return (
    <>
      <div className="card">
        <Table hover responsive className="mb-0">
          <thead>
            <tr>
              <th>Image</th>
              <th>
                <div
                  className="sort-cell d-flex align-items-center"
                  onClick={() => {
                    _sort({ key: "fname", order: _order === -1 ? 1 : -1 });
                    console.log(_order);
                  }}
                >
                  <label>Name</label>

                  <span className="ms-auto d-flex flex-column icon">
                    {sortKey == "fname" || _nameSort ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10"
                        height="14"
                        viewBox="0 0 10 14"
                      >
                        <g
                          id="Group_958"
                          data-name="Group 958"
                          transform="translate(-458 -170)"
                        >
                          {_order != 1 ? (
                            <path
                              id="Polygon_5"
                              data-name="Polygon 5"
                              d="M5,0l5,6H0Z"
                              transform="translate(468 184) rotate(180)"
                            />
                          ) : (
                            <path
                              id="Polygon_6"
                              data-name="Polygon 6"
                              d="M5,0l5,6H0Z"
                              transform="translate(458 170)"
                            />
                          )}
                        </g>
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10"
                        height="14"
                        viewBox="0 0 10 14"
                      >
                        <g
                          id="Group_958"
                          data-name="Group 958"
                          transform="translate(-458 -170)"
                        >
                          <path
                            id="Polygon_5"
                            data-name="Polygon 5"
                            d="M5,0l5,6H0Z"
                            transform="translate(468 184) rotate(180)"
                          />

                          <path
                            id="Polygon_6"
                            data-name="Polygon 6"
                            d="M5,0l5,6H0Z"
                            transform="translate(458 170)"
                          />
                        </g>
                      </svg>
                    )}
                  </span>
                </div>
              </th>
              <th>
                <div
                  className="sort-cell d-flex align-items-center"
                  onClick={() => {
                    _sort({
                      key: "roles.roleName",
                      order: _order === -1 ? 1 : -1,
                    });
                  }}
                >
                  <label>Assigned Role</label>
                  <span className="ms-auto d-flex flex-column icon">
                    {sortKey == "roles.roleName" ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10"
                        height="14"
                        viewBox="0 0 10 14"
                      >
                        <g
                          id="Group_958"
                          data-name="Group 958"
                          transform="translate(-458 -170)"
                        >
                          {_order != 1 ? (
                            <path
                              id="Polygon_5"
                              data-name="Polygon 5"
                              d="M5,0l5,6H0Z"
                              transform="translate(468 184) rotate(180)"
                            />
                          ) : (
                            <path
                              id="Polygon_6"
                              data-name="Polygon 6"
                              d="M5,0l5,6H0Z"
                              transform="translate(458 170)"
                            />
                          )}{" "}
                        </g>
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10"
                        height="14"
                        viewBox="0 0 10 14"
                      >
                        <g
                          id="Group_958"
                          data-name="Group 958"
                          transform="translate(-458 -170)"
                        >
                          <path
                            id="Polygon_5"
                            data-name="Polygon 5"
                            d="M5,0l5,6H0Z"
                            transform="translate(468 184) rotate(180)"
                          />
                          <path
                            id="Polygon_6"
                            data-name="Polygon 6"
                            d="M5,0l5,6H0Z"
                            transform="translate(458 170)"
                          />
                        </g>
                      </svg>
                    )}
                  </span>
                </div>
              </th>
              <th>
                <div
                  className="sort-cell d-flex align-items-center"
                  onClick={() => {
                    _sort({ key: "email", order: _order === -1 ? 1 : -1 });
                  }}
                >
                  <label>Email</label>
                  <span className="ms-auto d-flex flex-column icon">
                    {sortKey == "email" ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10"
                        height="14"
                        viewBox="0 0 10 14"
                      >
                        <g
                          id="Group_958"
                          data-name="Group 958"
                          transform="translate(-458 -170)"
                        >
                          {_order != 1 ? (
                            <path
                              id="Polygon_5"
                              data-name="Polygon 5"
                              d="M5,0l5,6H0Z"
                              transform="translate(468 184) rotate(180)"
                            />
                          ) : (
                            <path
                              id="Polygon_6"
                              data-name="Polygon 6"
                              d="M5,0l5,6H0Z"
                              transform="translate(458 170)"
                            />
                          )}{" "}
                        </g>
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10"
                        height="14"
                        viewBox="0 0 10 14"
                      >
                        <g
                          id="Group_958"
                          data-name="Group 958"
                          transform="translate(-458 -170)"
                        >
                          <path
                            id="Polygon_5"
                            data-name="Polygon 5"
                            d="M5,0l5,6H0Z"
                            transform="translate(468 184) rotate(180)"
                          />
                          <path
                            id="Polygon_6"
                            data-name="Polygon 6"
                            d="M5,0l5,6H0Z"
                            transform="translate(458 170)"
                          />
                        </g>
                      </svg>
                    )}
                  </span>
                </div>
              </th>

              <th>
                <div
                  className="sort-cell d-flex align-items-center"
                  onClick={() => {
                    _sort({
                      key: "deleted",
                      order: _order === -1 ? 1 : -1,
                    });
                  }}
                >
                  <label>Status</label>
                  <span className="ms-auto d-flex flex-column icon">
                    {sortKey == "deleted" ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10"
                        height="14"
                        viewBox="0 0 10 14"
                      >
                        <g
                          id="Group_958"
                          data-name="Group 958"
                          transform="translate(-458 -170)"
                        >
                          {_order == -1 ? (
                            <path
                              id="Polygon_5"
                              data-name="Polygon 5"
                              d="M5,0l5,6H0Z"
                              transform="translate(468 184) rotate(180)"
                            />
                          ) : (
                            <path
                              id="Polygon_6"
                              data-name="Polygon 6"
                              d="M5,0l5,6H0Z"
                              transform="translate(458 170)"
                            />
                          )}
                        </g>
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10"
                        height="14"
                        viewBox="0 0 10 14"
                      >
                        <g
                          id="Group_958"
                          data-name="Group 958"
                          transform="translate(-458 -170)"
                        >
                          <path
                            id="Polygon_5"
                            data-name="Polygon 5"
                            d="M5,0l5,6H0Z"
                            transform="translate(468 184) rotate(180)"
                          />

                          <path
                            id="Polygon_6"
                            data-name="Polygon 6"
                            d="M5,0l5,6H0Z"
                            transform="translate(458 170)"
                          />
                        </g>
                      </svg>
                    )}
                  </span>
                </div>
              </th>
              <th className="action-col" width="100">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {users?.docs?.map((item, i) => {
              return (
                <tr key={i}>
                  <td>
                    <img
                      src={
                        item?.blob_name
                          ? item?.blob_name
                          : require("../../../assets/img/no-image.png")
                      }
                      alt={item?.fname}
                      width="50"
                    />
                  </td>

                  <td>{item?.fname + " " + item?.lname}</td>
                  <td>{item?.roles?.roleName}</td>
                  <td>{item?.email}</td>
                  <td style={{ paddingLeft: "10px" }}>
                    {item?.deleted ? (
                      <Button color="link" data-tip="Inactive">
                        <FontAwesomeIcon icon={faCircleXmark} color="red" />
                        <ReactTooltip />
                      </Button>
                    ) : (
                      <Button color="link" data-tip="Active">
                        <FontAwesomeIcon icon={faCheckCircle} color="green" />
                        <ReactTooltip />
                      </Button>
                    )}
                  </td>
                  <td
                    className="action-btn-col action-cell"
                    style={{ padding: "10px 16px" }}
                  >
                    <div className="d-inline-flex align-items-center">
                      {(userId != item?._id) ? (
                        <Button
                          data-tip={item?.deleted ? "Activate" : "Deactivate"}
                          color="link"
                          className="icon-btn"
                          onClick={(val) => {
                            _handleUserStatusChange(item?._id, {
                              deleted: item?.deleted,
                            });
                          }}
                        >
                          {item?.deleted ? (
                            <FontAwesomeIcon icon={faRotate} />
                          ) : (
                            <FontAwesomeIcon icon={faTrash} />
                          )}
                        </Button>
                      ) : (
                        ""
                      )}
                      <Button
                        color="link"
                        data-tip="View"
                        className="icon-btn"
                        onClick={() =>
                          history.push({
                            pathname: "/user-detail",
                            state: { optdata: item },
                          })
                        }
                      >
                        <FontAwesomeIcon icon={faEye} />
                        <ReactTooltip />
                      </Button>

                      {(userId != item?._id) ? (
                        <Button
                          color="link"
                          data-tip="Edit"
                          className="icon-btn"
                          onClick={() => {
                            history.push("/edit-user", { id: item?._id });
                          }}
                        >
                          <FontAwesomeIcon icon={faEdit} />
                          <ReactTooltip />
                        </Button>
                      ) : (
                        ""
                      )}

                      {item?.accountSetup == false ? (
                        <Button
                          color="link"
                          data-tip="Resend Email"
                          className="icon-btn"
                          onClick={() => {
                            _resendEmail(item);
                          }}
                        >
                          <FontAwesomeIcon icon={faMailForward} />
                          <ReactTooltip />
                        </Button>
                      ) : (
                        ""
                      )}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        <PaginationBlock3
          _handleLimit={_handleLimit}
          _handlePageChange={_handlePageChange}
          organizations={users}
          page={page}
          limit={limit}
        />
      </div>
    </>
  );
};

export default Listing;
